import type { WidgetLocale } from '../../types/widgetLocale';
import type { WidgetMessages } from '../../types/widgetMessages';

import { WIDGET_MESSAGES_EN } from '../../i18n/widgetMessages.en';
import { WIDGET_MESSAGES_RU } from '../../i18n/widgetMessages.ru';

const WIDGET_MESSAGES_BY_LOCALE: Record<WidgetLocale, WidgetMessages> = {
  ru: WIDGET_MESSAGES_RU,
  en: WIDGET_MESSAGES_EN,
};

// Возвращает словарь строк для локали виджета, при неизвестной локали — русский язык
export function getWidgetMessages(locale: WidgetLocale): WidgetMessages {
  return WIDGET_MESSAGES_BY_LOCALE[locale] ?? WIDGET_MESSAGES_RU;
}
